import { z } from 'zod';

export const BankAccountSchema = z.object({
  id: z.string().min(1),
  legal_entity_id: z.string().min(1),
  account_number: z.string(),
  account_name: z.string(),
  currency: z.string().length(3),
  correspondent_bank: z.string(),
  swift_bic: z.string().nullable().optional(),
  account_type: z.string(),
  is_primary: z.boolean(),
  is_active: z.boolean(),
});

export const BankAccountListSchema = z.array(BankAccountSchema);

export const CreateBankAccountRequestSchema = z.object({
  legal_entity_id: z.string().min(1),
  account_number: z.string().min(1).max(50),
  account_name: z.string().min(1).max(200),
  currency: z.string().length(3),
  correspondent_bank: z.string().min(1).max(200),
  swift_bic: z.string().max(11).optional(),
  account_type: z.string().min(1),
  is_primary: z.boolean(),
});

/**
 * Mutable fields for an existing bank account.
 * The backend update DTO accepts account_number as mutable, while legal_entity_id,
 * currency, and account_type remain immutable guard fields.
 */
export const UpdateBankAccountRequestSchema = z.object({
  account_number: z.string().min(1).max(50),
  account_name: z.string().min(1).max(200),
  correspondent_bank: z.string().min(1).max(200),
  swift_bic: z.string().max(11).optional(),
  is_primary: z.boolean(),
});

export const BankAccountManagerPayloadSchema = z.object({
  legal_entity_id: z.string().min(1).optional(),
});

export type BankAccount = z.infer<typeof BankAccountSchema>;
export type CreateBankAccountRequest = z.infer<typeof CreateBankAccountRequestSchema>;
export type UpdateBankAccountRequest = z.infer<typeof UpdateBankAccountRequestSchema>;
export type BankAccountManagerPayload = z.infer<typeof BankAccountManagerPayloadSchema>;
